import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, take, tap } from 'rxjs/operators';
import { DateTimeUtil } from 'src/app/util/date-time-util';
import { DownloadFileUtil } from 'src/app/util/download-file-util';
import { EnvelopeInfo } from '../models/envelope-info';
import { VerificationPortalType } from 'src/app/enum/verification-portal-type.enum';

const CONTROLLER = 'VerificationPortal';
@Injectable({ providedIn: 'root' })
export class VerificationPortalService {
  constructor(private http: HttpClient) { }

  getHeaders() {
    const headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf'
    });
    const requestOptions = {
      headers: headerOptions,
      responseType: 'arraybuffer' as 'json', observe: 'response' as any
    };
    return requestOptions;
  }

  downloadPDF(envelopeId: any): Promise<any> {
    return this.getPDF(envelopeId).then((data) => {
      console.log(data);
      DownloadFileUtil.downloadFile(data);
    });
  }

  getPDF(verificationCode: any): Promise<any> {
    const requestOptions = this.getHeaders();
    return this.http.get(`${CONTROLLER}/downloadFile/${verificationCode}`, requestOptions)
      .pipe(
        tap((x: any) => console.log(x)),
        take(1),
        map((data: any) => data),
        catchError(this.handleError)
      ).toPromise();
  }

  downloadSignedPDF(envelopeId: any): Promise<any> {
    return this.getSignedPDF(envelopeId).then((data) => {
      DownloadFileUtil.downloadFile(data);
    });
  }

  getSignedPDF(verificationCode: any): Promise<any> {
    const requestOptions = this.getHeaders();
    return this.http.get(`${CONTROLLER}/downloadSignedFile/${verificationCode}`, requestOptions)
      .pipe(
        take(1),
        map((data: any) => data),
        catchError(this.handleError)
      ).toPromise();
  }

  downloadPrintingPDF(envelopeId: any, withStamp: boolean): Promise<any> {
    return this.getPrintingPDF(envelopeId, withStamp).then((data) => {
      DownloadFileUtil.downloadFile(data);
    });
  }

  getPrintingPDF(verificationCode: any, withStamp: boolean): Promise<any> {
    const requestOptions = this.getHeaders();
    const timezone = DateTimeUtil.getCurrentTimezone();

    return this.http.get(`${CONTROLLER}/report/${verificationCode}?timezone=${timezone}&withStamp=${withStamp}`, requestOptions)
      .pipe(
        take(1),
        map((data: any) => data),
        catchError(this.handleError)
      ).toPromise();
  }

  public getRedirectType(verificationCode: string) {
    return this.http
      .get<{ value: VerificationPortalType }>(`${CONTROLLER}/redirect-type/${verificationCode}`)
      .pipe(
        map((res) => res.value),
        catchError((err) => {
          return of(VerificationPortalType.verificationPortal);
        })
      );
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
    }
    console.log(error);
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  public generateToken(verificationCode: any, signatoryEmail: string): Observable<any> {
    return this.http.post(`${CONTROLLER}/generateToken`,
      { verificationCode: verificationCode, signatoryEmail: signatoryEmail });
  }

  public validateTokenAndAccessCode(verificarionCode: string, accessKey: string, accessToken: string): Observable<EnvelopeInfo> {
    const url = `${CONTROLLER}/${verificarionCode}/${accessKey}/${accessToken}`;
    return this.http.get(url).pipe(
      map((res: any) => res.value)
    );
  }

  public publicVerification(verificationCode: any, fileCode: any, requesterMail: string): Observable<any> {
    return this.http.post(`${CONTROLLER}/report/public-verification`,
      { EnvelopeVerificationCode: verificationCode?.toString(), EnvelopeValidateCode: fileCode, RequesterEmail: requesterMail });
  }
}
